<template>
  <v-flex class="search-bar" :class="{ 'mobile': mobileBigAndBelow }">
    <div class="input-group" :class="{'non-empty' : searchPhrase}">
      <div class="search-fields-container" v-show="showSearchFields">
        <button v-show="searchPhrase" class="back-icon" type="button" @click="goBack()"></button>
        <div v-show="!searchPhrase" class="search-icon" @click="toggleShowSearchPopup()">
          <icon name="icon-search"></icon>
        </div>
        <input
          type="search"
          name="search-filed"
          v-model="searchPhrase"
          @input="handleSearchInput"
          class="search-filed"
          ref="phrase"
          :placeholder="$t('Casino.Search.Input.Placeholder')"
          autocomplete="off"
          @keyup.enter="performSetPhraseAndSearchSearch(true)" />
        <button v-show="searchPhrase" class="reset-icon" type="reset" @click="resetSearchPhrase()"></button>
<!--        <span class="close-icon" :class="{ 'hidden': ['casino-search', 'search'].indexOf(currentRouteName) > -1 }" type="button" @click="toggleShowSearchPopup()">Close</span>-->
      </div>
    </div>
  </v-flex>
</template>

<script>
import store from '@/store'
import Icon from '@/components/common/Icon'
import Screen from '@/components/mixins/Screen'
import Casino from '@/components/mixins/Casino'
import config from '@/config'

export default {
  name: 'casinoSearchBar',
  components: {
    Icon
  },
  props: [],
  mixins: [
    Screen,
    Casino
  ],
  data () {
    return {
      numOfCharsToStartSearch: config.app.autoconf.CASINO.SEARCH_NUMBER_OF_CHARS_TO_START || 3,
      showSearchFieldsContainer: false,
      searchTimeoutObj: undefined
    }
  },
  computed: {
    searchPhrase: {
      get: () => {
        return store.getters['gap/getPhrase']
      },
      set: (value) => {
        // eslint-disable-next-line no-useless-escape
        let regex = new RegExp(/[^\p{L}\p{N} ]/, 'ug')
        let sanitizedInput = value.replace(regex, '')
        store.commit('gap/setPhrase', sanitizedInput)
      }
    },
    routeToExitSearch () {
      return store.getters['gap/getRouteToExitSearch']
    },
    showSearchFields () {
      return this.showSearchFieldsContainer || ['casino-search', 'search'].indexOf(this.currentRouteName) > -1
    },
    currentRouteName () {
      return this.$route.name
    }
  },
  methods: {
    toggleShowSearchPopup () {
      if (this.mobileBigAndBelow && ['casino-search', 'search'].indexOf(this.currentRouteName) === -1) {
        this.showSearchFieldsContainer = !this.showSearchFieldsContainer
      }
    },
    handleSearchInput (event) {
      // This method is used for preventing users from entering special characters
      let value = event.target.value
      // eslint-disable-next-line no-useless-escape
      let regex = new RegExp(/[^\p{L}\p{N} ]/, 'ug')
      let sanitizedInput = value.replace(regex, '')
      if (sanitizedInput !== value) {
        event.target.value = sanitizedInput
      }
    },
    performSetPhraseAndSearchSearch (noTimeout) {
      if (!this.searchPhrase) {
        this.resetSearch()
      } else {
        if (this.$route.name !== 'casino-search') {
          this.$router.push({name: 'casino-search'})
        }
        if (this.searchPhrase.length >= this.numOfCharsToStartSearch) {
          this.startSearch(noTimeout)
        } else {
          this.resetSearch()
        }
      }
    },
    resetSearchPhrase () {
      store.commit('gap/setPhrase', '')
    },
    resetSearch () {
      clearTimeout(this.searchTimeoutObj)
      store.dispatch('gap/clearCachedResults')
    },
    startSearch (noTimeout) {
      clearTimeout(this.searchTimeoutObj)
      this.searchTimeoutObj = setTimeout(() => {
        store.dispatch('gap/fetchSearchResults')
        // this.clientSideSearch()
      }, noTimeout ? 0 : 1000)
    },
    goBack () {
      this.$router.back()
    }
  },
  mounted () {
    this.resetSearchPhrase()
  },
  watch: {
    searchPhrase () {
      store.commit('gap/setGamesLoaded', false)
      this.performSetPhraseAndSearchSearch()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/igaming/partials/casinoSearch/casinoSearchBar.vue